export function getBaseUrl() {
  const currentPath = location.pathname.startsWith('/blog/') ? '/blog' : ''
  return currentPath;
}

export function initSubscribeForm() {
  const form = document.querySelector('#po-subscribe-form');
  if (!form) return;

  const msgEl = form.querySelector('.po-subscribe-message');
  const inputWrap = form.querySelector('.subscribe-block__input-wrap');

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    if (!msgEl) {
      console.warn('Не найден элемент .po-subscribe-message');
      return;
    }

    const payload = {
      email: form.email.value,
      lang: form.lang.value,
      post_slug: form.post_slug.value,
      post_cat_slug: form.post_cat_slug.value,
    };

    try {
      const res = await fetch(`${getBaseUrl()}/wp-json/po/v1/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      msgEl.textContent = result.message || 'Ошибка';
      msgEl.classList.add('active');

      if (result.success && inputWrap) {
        inputWrap.style.display = 'none';
      }
    } catch (error) {
      console.error('Ошибка при отправке формы:', error);
      msgEl.textContent = 'Ошибка сервера. Попробуйте позже.';
      msgEl.classList.add('active');
    }
  });
}